import {createTheme} from '@mui/material';
import { ptBR as dataGridPtBR } from '@mui/x-data-grid';
import { ptBR as corePtBR } from '@mui/material/locale';
import { ptBR } from '@mui/x-date-pickers/locales';
import { light } from '@mui/material/styles/createPalette';

declare module '@mui/material'
{
	interface TypographyVariants
	{
		h0: React.CSSProperties
		hb0: React.CSSProperties
		hb1: React.CSSProperties
		hb2: React.CSSProperties
		hb3: React.CSSProperties
		hb4: React.CSSProperties
		pl: React.CSSProperties
		pm: React.CSSProperties
		ps: React.CSSProperties
		pxs: React.CSSProperties
		pbl: React.CSSProperties
		pbm: React.CSSProperties
		pbs: React.CSSProperties
		pbxs: React.CSSProperties
		bm: React.CSSProperties
		bs: React.CSSProperties
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		h0?: React.CSSProperties
		hb0?: React.CSSProperties
		hb1?: React.CSSProperties
		hb2?: React.CSSProperties
		hb3?: React.CSSProperties
		hb4?: React.CSSProperties
		pl?: React.CSSProperties
		pm?: React.CSSProperties
		ps?: React.CSSProperties
		pxs?: React.CSSProperties
		pbl?: React.CSSProperties
		pbm?: React.CSSProperties
		pbs?: React.CSSProperties
		pbxs?: React.CSSProperties
		bm?: React.CSSProperties
		bs?: React.CSSProperties
	}
}

// Update the Typography's variant prop options
declare module '@mui/material' {
	interface TypographyPropsVariantOverrides {
		h0: true;
		hb0: true;
		hb1: true;
		hb2: true;
		hb3: true;
		hb4: true;
		pl: true;
		pm: true;
		ps: true;
		pxs: true;
		pbl: true;
		pbm: true;
		pbs: true;
		pbxs: true;
		bm: true;
		bs: true;
	}
	interface BreakpointOverrides
	{
		lgg: true; // removes the `xs` breakpoint
		xm: true;
	}
}

const padrao = {
	typography:
	{
		fontFamily:
		{
			primary:
			{
				ligth: 'dt_amplalight',
				book: 'dt_amplabook',
				regular: 'dt_amplaregular',
				semibold: 'dt_amplasemibold',
				bold: 'dt_amplabold',
			},
			secondary: 'Roboto' /* ROBOTO */
		}
	}
};

const appTema = createTheme({
	breakpoints: {
		keys: ["xs", "xm", "sm", "md", "lg", "lgg", "xl"],
		values: {
			xs: 0,
			xm: 568,
			sm: 768,
			md: 1024,
			lg: 1326,
			lgg: 1680,
			xl: 1900
		}
	},
	typography: {
		htmlFontSize: 16,

		fontFamily: padrao.typography.fontFamily.secondary,
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500,
		fontWeightBold: 700,
		h0:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: "2.25rem",  fontWeight: 400, lineHeight: '3.25rem' },
		h1:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '2rem',     fontWeight: 400, lineHeight: '2.875rem' },
		h2:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.75rem',  fontWeight: 400, lineHeight: '2.5rem' },
		h3:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.5rem',   fontWeight: 400, lineHeight: '2.125rem' },
		h4:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.25rem',  fontWeight: 400, lineHeight: '1.75rem' },

		hb0:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '2.25rem',  fontWeight: 700, lineHeight: '3.25rem' },
		hb1:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '2rem',     fontWeight: 700, lineHeight: '2.875rem' },
		hb2:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.75rem',  fontWeight: 700, lineHeight: '2.5rem' },
		hb3:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.5rem',   fontWeight: 700, lineHeight: '2.125rem' },
		hb4:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.25rem',  fontWeight: 700, lineHeight: '1.75rem' },

		pl:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.5rem',   fontWeight: 400, lineHeight: '2.125rem' },
		pm:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.25rem',  fontWeight: 400, lineHeight: '1.75rem' },
		ps:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1rem',     fontWeight: 400, lineHeight: '1.375rem' },
		pxs:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '0.875rem', fontWeight: 500, lineHeight: '1.125rem' },

		pbl:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.5rem',   fontWeight: 900, lineHeight: '2.125rem' },
		pbm:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1.25rem',  fontWeight: 900, lineHeight: '1.75rem' },
		pbs:    { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1rem',     fontWeight: 900, lineHeight: '1.375rem' },
		pbxs:   { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '0.875rem', fontWeight: 900, lineHeight: '1.125rem' },

		bm:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '1rem',     fontWeight: 500, lineHeight: '1.375rem', textTransform: 'uppercase' },
		bs:     { fontFamily: padrao.typography.fontFamily.secondary,    fontSize: '0.875rem', fontWeight: 500, lineHeight: '1.125rem', textTransform: 'uppercase' },
	},
	palette: {
		primary: {
			main: '#39aec0',
			contrastText: '#fff',
		},
		secondary: {
			main: '#132190',
			//light: '#132190',
			contrastText: '#fff',
		},
		error: {
			main: '#f9423a',
			contrastText: '#fff',
		},
		info: {
			main: '#010451',
			contrastText: '#fff',
		},
		success: {
			main: '#46b854',
			contrastText: '#fff',
		},
		warning: {
			main: '#ffb81e',
			contrastText: '#fff',
		},
		background: {
			// default: "???",
			// paper: "???"
		},
	},
	components: {
		MuiLinearProgress: {
			defaultProps: {
				color: "info",
			},
			styleOverrides: {
				root: {
					height: '2px',
				}
			}
		},
		MuiCircularProgress: {
			defaultProps: {
				color: "info"
			}
		},
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					h0: 'span',
					h1: 'h1',
					h2: 'h2',
					h3: 'h3',
					h4: 'h4',
					h5: 'h5',
					h6: 'h6',
					subtitle1: 'h3',
					subtitle2: 'h4',
					body1: 'p',
					body2: 'span',
					hb1: 'span',
					hb2: 'span',
					hb3: 'span',
					hb4: 'span',
					pl: 'span',
					pm: 'span',
					ps: 'span',
					pxs: 'span',
					pbl: 'span',
					pbm: 'span',
					pbs: 'span',
					bm: 'span',
					bs: 'span',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					minWidth: '10rem',
				}
			}
		},
	},
}, ptBR, dataGridPtBR, corePtBR);

export default appTema;